/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_TitleInputs */

const en_admin_design_settings_title = /** @type {(inputs: Admin_Design_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colors`)
};

const de_admin_design_settings_title = /** @type {(inputs: Admin_Design_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farben`)
};

/**
* | output |
* | --- |
* | "Colors" |
*
* @param {Admin_Design_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_title = /** @type {((inputs?: Admin_Design_Settings_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_title(inputs)
	return en_admin_design_settings_title(inputs)
});